import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettyPrice',
})
export class PrettyPricePipe implements PipeTransform {
  transform(val: number): string {
    // Create our number formatter.
    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',

      // These options are needed to round to whole numbers if that's what you want.
      //MinimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return formatter.format(val); /* $2,500.00 */
  }
}